import {
  Root as uiTabs,
  List as uiTabsList,
  Trigger as uiTabsTrigger,
} from '@midwest/web/tabs';
import { desktop, tablet } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

export const Container = styled.section`
  margin: 0;
  width: 100%;
  min-height: 420px;

  ${desktop} {
    margin-right: 2rem;
    border: 1px solid;
    border-color: ${(p) => p.theme.midwestColors.borderDefault};
  }
`;

export const Tabs = styled(uiTabs)``;

export const TabsList = styled(uiTabsList)`
  background-color: ${(p) => p.theme.midwestColors.backgroundSecondary};
  margin: 0;
  padding: 1rem 0.5rem;
  ${desktop} {
    border-bottom-color: ${(p) => p.theme.midwestColors.borderDefault};
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }
`;

export const TabsTrigger = styled(uiTabsTrigger)`
  color: ${(p) => p.theme.midwestColors.neutralDarkStrong};
  border-right-color: ${(p) => p.theme.midwestColors.borderDefault};
  border-right-style: solid;
  border-right-width: 1px;
  padding: 0 0.5rem;
  ${tablet} {
    padding: 1rem 1rem;
    font-size: 0.875rem;
  }
  text-align: left;
  font-weight: 400;
  height: 2rem;
  &:last-of-type {
    border-right: none;
  }
  &[data-state='active'] {
    color: ${(p) => p.theme.midwestColors.neutralDarkHeavy};
    border-bottom: none;
    background: none;
    padding: 0 0.5rem;
    ${tablet} {
      padding: 1rem 1rem;
    }
  }
  &:hover,
  &:focus {
    color: ${(p) => p.theme.midwestColors.neutralDarkHeavy};
    background: none;
  }
`;

export const TabText = styled(MDSText.BodyRegSm)`
  font-size: 0.75rem;
  ${tablet} {
    font-size: 0.875rem;
  }
  [data-state='active'] & {
    font-weight: 600;
  }
`;
